module.exports = __webpack_public_path__ + "img/20191127163146357.2989949d.jpg";